import Icon from "@/components/common/icon";

export default function Tg() {
  return (
    <a
      href="https://t.me/farkop_rubot"
      target="_blank"
      rel="noreferrer"
      id="tgLink"
    >
      <Icon id="tg" />
    </a>
  );
}
